export const countries = [
  "Afghanistan", "Egypt", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia",
  "Azerbaijan", "Australia", "Bahamas", "Bahrain", "Bangladesh", "Belgium", "Bolivia", "Bosnia and Herzegovina",
  "Brazil", "Bulgaria", "Chile", "China", "Costa Rica", "Denmark", "Germany", "Dominican Republic",
  "Ecuador", "El Salvador", "Estonia", "Finland", "France", "Georgia", "Greece", "Guatemala", "Haiti",
  "Honduras", "India", "Indonesia", "Ireland", "Iceland", "Israel", "Italy", "Japan", "Cambodia", "Canada",
  "Kenya", "Colombia", "Croatia", "Laos", "Latvia", "Lebanon", "Liechtenstein", "Lithuania", "Luxembourg",
  "Malaysia", "Malta", "Morocco", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Namibia",
  "Nepal", "New Zealand", "Netherlands", "Nigeria", "North Macedonia", "Norway", "Austria", "Pakistan",
  "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Romania", "Russia", "Saudi Arabia",
  "Sweden", "Switzerland", "Serbia", "Singapore", "Slovakia", "Slovenia", "Spain", "Sri Lanka", "South Africa",
  "South Korea", "Taiwan", "Thailand", "Czech Republic", "Tunisia", "Turkey", "Ukraine", "Hungary", "Uruguay",
  "United States", "United Kingdom", "Vietnam", "Cyprus"
]

export const nationalities = [
  "Afghan", "Egyptian", "Albanian", "Algerian", "Andorran", "Angolan", "Argentinian",
  "Armenian", "Azerbaijani", "Australian", "Bahamian", "Bahraini", "Bangladeshi", "Belgian",
  "Bolivian", "Bosnian", "Brazilian", "Bulgarian", "Chilean", "Chinese", "Costa Rican",
  "Danish", "German", "Dominican", "Ecuadorian", "Estonian", "Finnish", "French", "Georgian",
  "Greek", "Guatemalan", "Haitian", "Honduran", "Indian", "Indonesian", "Irish",
  "Icelandic", "Israeli", "Italian", "Japanese", "Cambodian", "Canadian", "Kenyan",
  "Colombian", "Croatian", "Lao", "Latvian", "Lebanese", "Liechtenstein", "Lithuanian",
  "Luxembourgish", "Malaysian", "Maltese", "Moroccan", "Mexican", "Moldovan", "Monégasque",
  "Mongolian", "Montenegrin", "Namibian", "Nepalese", "New Zealander", "Dutch",
  "Nigerian", "North Macedonian", "Norwegian", "Austrian", "Pakistani", "Panamanian",
  "Paraguayan", "Peruvian", "Filipino", "Polish", "Portuguese", "Romanian", "Russian",
  "Saudi Arabian", "Swedish", "Swiss", "Serbian", "Singaporean", "Slovak", "Slovenian",
  "Spanish", "Sri Lankan", "South African", "South Korean", "Taiwanese", "Thai",
  "Czech", "Tunisian", "Turkish", "Ukrainian", "Hungarian", "Uruguayan", "American",
  "British", "Vietnamese", "Cypriot"
]

export const euLanguages = [
  "Bulgarian", "Croatian", "Czech", "Danish", "Dutch", "English", "Estonian",
  "Finnish", "French", "German", "Greek", "Hungarian", "Italian", "Latvian",
  "Lithuanian", "Maltese", "Polish", "Portuguese", "Romanian", "Slovak",
  "Slovenian", "Spanish", "Swedish"
]

export const euipoLanguages = ["English", "French", "German", "Italian", "Spanish"]

export const pctPublicationLanguages = [
  "Arabic",
  "Chinese",
  "English",
  "French",
  "German",
  "Japanese",
  "Korean",
  "Portuguese",
  "Russian",
  "Spanish"
]

export const epoAdmissibleNonOfficialLanguages = [
  "Albanian",
  "Bulgarian",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "Estonian",
  "Finnish",
  "Greek",
  "Hungarian",
  "Icelandic",
  "Irish",
  "Italian",
  "Latvian",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Maltese",
  "Montenegrin",
  "Norwegian",
  "Polish",
  "Portuguese",
  "Romanian",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Spanish",
  "Swedish",
  "Turkish"
]

export const isoCountryMap: Record<string, string> = {
  AF: "Afghanistan",
  EG: "Egypt",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AR: "Argentina",
  AM: "Armenia",
  AZ: "Azerbaijan",
  AU: "Australia",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BE: "Belgium",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BR: "Brazil",
  BG: "Bulgaria",
  CL: "Chile",
  CN: "China",
  CR: "Costa Rica",
  DK: "Denmark",
  DE: "Germany",
  DO: "Dominican Republic",
  EC: "Ecuador",
  SV: "El Salvador",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  GE: "Georgia",
  GR: "Greece",
  GT: "Guatemala",
  HT: "Haiti",
  HN: "Honduras",
  IN: "India",
  ID: "Indonesia",
  IE: "Ireland",
  IS: "Iceland",
  IL: "Israel",
  IT: "Italy",
  JP: "Japan",
  KH: "Cambodia",
  CA: "Canada",
  KE: "Kenya",
  CO: "Colombia",
  HR: "Croatia",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MY: "Malaysia",
  MT: "Malta",
  MA: "Morocco",
  MX: "Mexico",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  NA: "Namibia",
  NP: "Nepal",
  NZ: "New Zealand",
  NL: "Netherlands",
  NG: "Nigeria",
  MK: "North Macedonia",
  NO: "Norway",
  AT: "Austria",
  PK: "Pakistan",
  PA: "Panama",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  RU: "Russia",
  SA: "Saudi Arabia",
  SE: "Sweden",
  CH: "Switzerland",
  RS: "Serbia",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  LK: "Sri Lanka",
  ZA: "South Africa",
  KR: "South Korea",
  TW: "Taiwan",
  TH: "Thailand",
  CZ: "Czech Republic",
  TN: "Tunisia",
  TR: "Turkey",
  UA: "Ukraine",
  HU: "Hungary",
  UY: "Uruguay",
  US: "United States",
  GB: "United Kingdom",
  VN: "Vietnam",
  CY: "Cyprus"
}

export const isoNationalityMap: Record<string, string> = {
  AF: "Afghan",
  EG: "Egyptian",
  AL: "Albanian",
  DZ: "Algerian",
  AD: "Andorran",
  AO: "Angolan",
  AR: "Argentinian",
  AM: "Armenian",
  AZ: "Azerbaijani",
  AU: "Australian",
  BS: "Bahamian",
  BH: "Bahraini",
  BD: "Bangladeshi",
  BE: "Belgian",
  BO: "Bolivian",
  BA: "Bosnian",
  BR: "Brazilian",
  BG: "Bulgarian",
  CL: "Chilean",
  CN: "Chinese",
  CR: "Costa Rican",
  DK: "Danish",
  DE: "German",
  DO: "Dominican",
  EC: "Ecuadorian",
  EE: "Estonian",
  FI: "Finnish",
  FR: "French",
  GE: "Georgian",
  GR: "Greek",
  GT: "Guatemalan",
  HT: "Haitian",
  HN: "Honduran",
  IN: "Indian",
  ID: "Indonesian",
  IE: "Irish",
  IS: "Icelandic",
  IL: "Israeli",
  IT: "Italian",
  JP: "Japanese",
  KH: "Cambodian",
  CA: "Canadian",
  KE: "Kenyan",
  CO: "Colombian",
  HR: "Croatian",
  LA: "Lao",
  LV: "Latvian",
  LB: "Lebanese",
  LI: "Liechtenstein",
  LT: "Lithuanian",
  LU: "Luxembourgish",
  MY: "Malaysian",
  MT: "Maltese",
  MA: "Moroccan",
  MX: "Mexican",
  MD: "Moldovan",
  MC: "Monégasque",
  MN: "Mongolian",
  ME: "Montenegrin",
  NA: "Namibian",
  NP: "Nepalese",
  NZ: "New Zealander",
  NL: "Dutch",
  NG: "Nigerian",
  MK: "North Macedonian",
  NO: "Norwegian",
  AT: "Austrian",
  PK: "Pakistani",
  PA: "Panamanian",
  PY: "Paraguayan",
  PE: "Peruvian",
  PH: "Filipino",
  PL: "Polish",
  PT: "Portuguese",
  RO: "Romanian",
  RU: "Russian",
  SA: "Saudi Arabian",
  SE: "Swedish",
  CH: "Swiss",
  RS: "Serbian",
  SG: "Singaporean",
  SK: "Slovak",
  SI: "Slovenian",
  ES: "Spanish",
  LK: "Sri Lankan",
  ZA: "South African",
  KR: "South Korean",
  TW: "Taiwanese",
  TH: "Thai",
  CZ: "Czech",
  TN: "Tunisian",
  TR: "Turkish",
  UA: "Ukrainian",
  HU: "Hungarian",
  UY: "Uruguayan",
  US: "American",
  GB: "British",
  VN: "Vietnamese",
  CY: "Cypriot"
}

// EPO extension-agreement and validation-agreement states (Art. 79(1) EPC
// designation is automatic for all contracting states; these are the
// separate, optional extension/validation requests). Shared by the EP1001
// designation-states form (DesignationStatesSection) and the EP1200
// entry-into-European-phase form (PatentEpPhaseFormPage) so the two never
// drift apart when the EPO adds or removes a state.
export const EPO_EXTENSION_STATES = [
  { code: "BA", label: "Bosnia and Herzegovina" }
]

export const EPO_VALIDATION_STATES = [
  { code: "MA", label: "Morocco" },
  { code: "TN", label: "Tunisia" },
  { code: "KH", label: "Cambodia" },
  { code: "GE", label: "Georgia" },
  { code: "LA", label: "Lao People's Democratic Republic" }
]
